!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("react-router-dom"), require("path-parser"), require("lodash"), require("react-redux"), require("axios"), require("jwt-decode"), require("moment"), require("qs"), require("prop-types")) : "function" == typeof define && define.amd ? define(["exports", "react", "react-router-dom", "path-parser", "lodash", "react-redux", "axios", "jwt-decode", "moment", "qs", "prop-types"], t) : t((e = e || self)["ipc-core"] = {}, e.React, e.reactRouterDom, e.Path, e._, e.reactRedux, e.axios, e.jwtDecode, e.moment, e.qs, e.PropTypes);
}(this, function (e, t, n, r, o, a, i, u, c, s, l) {
  "use strict";

  var f = "default" in t ? t.default : t;
  r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r, o = o && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o, i = i && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i, u = u && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u, c = c && Object.prototype.hasOwnProperty.call(c, "default") ? c.default : c, s = s && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s, l = l && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;

  var p = function p(e) {
    return f.createElement(n.HashRouter, e);
  };

  p.displayName = "IPCRouter";

  var d = n.withRouter,
      h = function h(e) {
    return f.createElement(n.Route, e);
  };

  function g(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function y(e, t) {
    if (e) {
      if ("string" == typeof e) return g(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? g(e, t) : void 0;
    }
  }

  function m(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var n = [],
            r = !0,
            o = !1,
            a = void 0;

        try {
          for (var i, u = e[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, a = e;
        } finally {
          try {
            r || null == u.return || u.return();
          } finally {
            if (o) throw a;
          }
        }

        return n;
      }
    }(e, t) || y(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function v(e, t) {
    if (null == e) return {};

    var n,
        r,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          a = Object.keys(e);

      for (r = 0; r < a.length; r++) {
        n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);

      for (r = 0; r < a.length; r++) {
        n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  function k(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function b(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function O(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? b(Object(n), !0).forEach(function (t) {
        k(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  h.displayName = "IPCRoute";

  var w = new r("/"),
      _ = function _(e, t, n) {
    return function (e) {
      return Boolean(w.partialTest(e));
    }(e) && !function (e, t) {
      var n = new r("/:lang<(".concat(o.join(t, "|"), ")>"));
      return Boolean(n.partialTest(e));
    }(e, t) ? "/".concat(n).concat(e) : e;
  },
      I = t.createContext({}),
      j = function j(e, t) {
    return "CHANGE_LANGUAGE" === t.type ? {
      supportedLanguages: e.supportedLanguages,
      defaultLanguage: e.defaultLanguage,
      currentLanguage: t.lang
    } : e;
  },
      L = function L(e) {
    var n = e.defaultLanguage,
        r = e.supportedLanguages,
        o = e.children,
        a = {
      defaultLanguage: n,
      currentLanguage: n,
      supportedLanguages: r
    };
    return f.createElement(I.Provider, {
      value: t.useReducer(j, a)
    }, o);
  };

  L.displayName = "LanguageProvider";

  var A = I.Consumer,
      E = function E() {
    return t.useContext(I);
  },
      T = function T(e, t, n) {
    return "string" == typeof e ? _(e, t, n) : O(O({}, e), {}, {
      pathname: _(e.pathname, t, n)
    });
  },
      P = function P(e) {
    var t = e.to,
        r = v(e, ["to"]),
        o = m(E(), 1)[0],
        a = o.supportedLanguages,
        i = o.currentLanguage;
    return f.createElement(n.Redirect, Object.assign({}, r, {
      to: T(t, a, i)
    }));
  },
      R = function R(e) {
    var t = e.location,
        r = m(E(), 1)[0].defaultLanguage;
    return f.createElement(n.Redirect, {
      to: "/".concat(r).concat(t.pathname)
    });
  },
      S = function S(e) {
    return e.pathname.split("/")[1];
  },
      x = function x(e, t, n) {
    return !!function (e, t) {
      return e.pathname.match("/(".concat(o.join(t, "|"), ")"));
    }(e, t) && S(e) !== n;
  },
      C = function C(e) {
    return f.createElement(n.MemoryRouter, e);
  };

  function q(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function H(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function N(e, t, n) {
    return t && H(e.prototype, t), n && H(e, n), e;
  }

  C.displayName = "IPCMemoryRouter";

  var D = function () {
    function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
        loggingIn: !1,
        loggedIn: !1,
        username: "",
        roles: [],
        token: "",
        error: ""
      };
      q(this, e), this.loggingIn = !1, this.loggedIn = !1, this.username = "", this.roles = [], this.token = "", this.error = "", this.loggingIn = t.loggingIn, this.loggedIn = t.loggedIn, this.username = t.username, this.roles = t.roles, this.token = t.token, this.error = t.error;
    }

    return N(e, [{
      key: "setLoggingIn",
      value: function value(e) {
        return this.loggingIn = e, this;
      }
    }, {
      key: "setLoggedIn",
      value: function value(e) {
        return this.loggedIn = e, this;
      }
    }, {
      key: "setUsername",
      value: function value(e) {
        return this.username = e, this;
      }
    }, {
      key: "setToken",
      value: function value(e) {
        return this.token = e, this;
      }
    }, {
      key: "setRoles",
      value: function value(e) {
        return this.roles = e, this;
      }
    }, {
      key: "setError",
      value: function value(e) {
        return this.error = e, this;
      }
    }, {
      key: "isAuthenticated",
      value: function value() {
        return this.loggedIn;
      }
    }]), e;
  }(),
      U = function U(e) {
    var t = e.Component,
        n = e.auth,
        r = e.autoRedirectToLogin,
        o = void 0 === r || r,
        a = e.loginPath,
        i = void 0 === a ? "/login" : a,
        u = e.render,
        c = v(e, ["Component", "auth", "autoRedirectToLogin", "loginPath", "render"]);
    return function (e) {
      var r = e.location;
      return n.isAuthenticated() ? t ? f.createElement(t, Object.assign({}, e, c)) : u(e) : o ? f.createElement(P, {
        to: {
          pathname: i,
          state: {
            from: r
          }
        }
      }) : null;
    };
  },
      G = a.connect(function (e) {
    return {
      authentication: new D(e.global.auth)
    };
  })(function (e) {
    var t = e.component,
        n = e.authentication,
        r = e.autoRedirectToLogin,
        o = e.loginPath,
        a = e.render,
        i = v(e, ["component", "authentication", "autoRedirectToLogin", "loginPath", "render"]);
    return f.createElement(h, Object.assign({
      render: U({
        Component: t,
        auth: n,
        autoRedirectToLogin: r,
        loginPath: o,
        render: a
      })
    }, i));
  }),
      B = "undefined" == typeof localStorage ? null : window.localStorage,
      z = function z() {
    return {};
  },
      F = function F() {
    console.error("Handle your authorization handler here");
  },
      M = function M() {
    console.error("Token has expired. If you want to handle this implement tokenExpirationHandler");
  },
      K = function () {
    function e(t, n, r) {
      var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : M,
          a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : F;
      q(this, e), this.clientId = t, this.secret = n, this.host = r, this.tokenExpirationHandler = o, this.noAuthorizationHandler = a, this._decryptedToken = {
        authorities: []
      }, this.prepareAxios();
    }

    return N(e, [{
      key: "_doAuthentication",
      value: function value(e) {
        this.token = e.access_token, this.tokenType = e.token_type, this.refreshToken = e.refresh_token, this.decryptedToken = this.decryptToken(this.token), this._setAxiosDefaults();
      }
    }, {
      key: "_failedAuthentication",
      value: function value() {
        this.token = "", this.tokenType = "", this.refreshToken = "";
      }
    }, {
      key: "_doPost",
      value: function value(e) {
        var t = this,
            n = e.url,
            r = e.queryParams,
            o = e.callback;
        i.post(n, s.stringify(r), {
          crossDomain: !0,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          },
          withCredentials: !0,
          auth: {
            username: this.clientId,
            password: this.secret
          }
        }).then(function (e) {
          t._doAuthentication(e.data), o({
            data: e.data
          });
        }).catch(function (e) {
          t._failedAuthentication(), o({
            error: e
          });
        });
      }
    }, {
      key: "_setAxiosDefaults",
      value: function value() {
        i.defaults.headers.common.Authorization = "".concat(this.tokenType, " ").concat(this.token);
      }
    }, {
      key: "_setAxiosInterceptors",
      value: function value() {
        var e = this;
        i.interceptors.response.use(function (e) {
          return e;
        }, function (t) {
          try {
            var n = t.config;

            if (401 === t.response.status && !n._retry) {
              if (n._retry = !0, 401 === (r = t.response).status && r.data && "com.auth0.jwt.exceptions.TokenExpiredException" === r.data.exception) return e.refresh({
                host: e.host,
                callback: function callback(t) {
                  var r = t.data,
                      o = t.error;
                  o ? (e.logout(), e.tokenExpirationHandler(o.response)) : (n.headers.Authorization = "".concat(r.token_type, " ").concat(r.access_token), i(n));
                }
              });
              e.logout(), e.noAuthorizationHandler(t.response);
            }
          } catch (e) {
            return Promise.reject(t);
          }

          var r;
          return Promise.reject(t);
        });
      }
    }, {
      key: "prepareAxios",
      value: function value() {
        this.loggedIn() && this._setAxiosDefaults(), this._setAxiosInterceptors();
      }
    }, {
      key: "login",
      value: function value(e) {
        var t = e.username,
            n = e.password,
            r = e.callback,
            o = void 0 === r ? z : r;

        this._doPost({
          url: "".concat(this.host, "/oauth/token"),
          queryParams: {
            client_id: this.clientId,
            username: t,
            password: n,
            grant_type: "password"
          },
          callback: o
        });
      }
    }, {
      key: "refresh",
      value: function value(e) {
        e.host;
        var t = e.callback;

        this._doPost({
          url: "".concat(this.host, "/oauth/token"),
          queryParams: {
            client_id: this.clientId,
            client_secret: this.secret,
            grant_type: "refresh_token",
            access_token: this.token,
            refresh_token: this.refreshToken
          },
          callback: t
        });
      }
    }, {
      key: "decryptToken",
      value: function value(e) {
        return u(e);
      }
    }, {
      key: "hasRole",
      value: function value(e) {
        var t = e.role;
        return !(!this._decryptedToken || !this._decryptedToken.authorities) && -1 !== this._decryptedToken.authorities.indexOf(t);
      }
    }, {
      key: "logout",
      value: function value() {
        B && (B.removeItem("id_token"), B.removeItem("token_type"), B.removeItem("refresh_token"));
      }
    }, {
      key: "loggedIn",
      value: function value() {
        return !!B && !!this.token && !this.isTokenExpired();
      }
    }, {
      key: "isTokenExpired",
      value: function value() {
        var e = this.decryptToken(this.token).exp;
        return c.unix(e).isBefore(c());
      }
    }, {
      key: "roles",
      value: function value() {
        return [];
      }
    }, {
      key: "token",
      get: function get() {
        if (B) return B.getItem("id_token");
      },
      set: function set(e) {
        B && B.setItem("id_token", e);
      }
    }, {
      key: "tokenType",
      get: function get() {
        if (B) return B.getItem("token_type");
      },
      set: function set(e) {
        B && B.setItem("token_type", e);
      }
    }, {
      key: "refreshToken",
      get: function get() {
        if (B) return B.getItem("refresh_token");
      },
      set: function set(e) {
        B && B.setItem("refresh_token", e);
      }
    }, {
      key: "decryptedToken",
      get: function get() {
        return this._decryptedToken;
      },
      set: function set(e) {
        this._decryptedToken = e;
      }
    }]), e;
  }();

  function J(e) {
    return function (e) {
      if (Array.isArray(e)) return g(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || y(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function V(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function $(e, t) {
    return ($ = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function Q(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && $(e, t);
  }

  function W(e) {
    return (W = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function X() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }

  function Y(e) {
    return (Y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function Z(e, t) {
    return !t || "object" !== Y(t) && "function" != typeof t ? V(e) : t;
  }

  function ee(e) {
    return function () {
      var t,
          n = W(e);

      if (X()) {
        var r = W(this).constructor;
        t = Reflect.construct(n, arguments, r);
      } else t = n.apply(this, arguments);

      return Z(this, t);
    };
  }

  function te(e, t, n) {
    return (te = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
      var r = function (e, t) {
        for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = W(e));) {
          ;
        }

        return e;
      }(e, t);

      if (r) {
        var o = Object.getOwnPropertyDescriptor(r, t);
        return o.get ? o.get.call(n) : o.value;
      }
    })(e, t, n || e);
  }

  var ne = function ne() {
    return {};
  },
      re = "undefined" == typeof localStorage ? null : window.localStorage,
      oe = function (e) {
    Q(n, e);
    var t = ee(n);

    function n() {
      var e, r;
      q(this, n);

      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) {
        a[i] = arguments[i];
      }

      return (r = t.call.apply(t, [this].concat(a))).login = function (t) {
        var o = t.username,
            a = t.password,
            i = t.callback,
            u = void 0 === i ? ne : i,
            c = r.loginCallBackInterceptor(u);
        te((e = V(r), W(n.prototype)), "login", e).call(e, {
          username: o,
          password: a,
          callback: c
        });
      }, r;
    }

    return N(n, [{
      key: "roles",
      value: function value() {
        if (re) {
          var e = JSON.parse(re.getItem("roles"));
          if (e) return J(e);
        }

        return [];
      }
    }, {
      key: "setRoles",
      value: function value(e) {
        re && re.setItem("roles", JSON.stringify(e));
      }
    }, {
      key: "loginCallBackInterceptor",
      value: function value(e) {
        var t = this;
        return function (n) {
          var r = n.error,
              o = n.data;
          r ? e({
            error: r,
            data: o
          }) : i.get(process.env.rolesendpoint).then(function (n) {
            if (200 === n.status) {
              t.setRoles(n.data);
              var a = O(O({}, o), {}, {
                roles: n.data
              });
              e({
                error: r,
                data: a
              });
            }
          }).catch(function (t) {
            return e({
              error: t
            });
          });
        };
      }
    }, {
      key: "logout",
      value: function value() {
        te(W(n.prototype), "logout", this).call(this), re && re.removeItem("roles");
      }
    }]), n;
  }(K),
      ae = process.env,
      ie = ae.oauthClientId,
      ue = ae.oauthSecret,
      ce = ae.oauthHost,
      se = ae.dummyOAuth,
      le = function e() {
    q(this, e), this.token = "THIS_IS_A_FAKE_TOKEN", this.loggedIn = function () {
      return !0;
    }, this.login = function (e) {
      (0, e.callback)({
        data: {
          token: "THIS_IS_A_FAKE_TOKEN"
        }
      });
    }, this.logout = function () {};
  },
      fe = process.env.rolesendpoint,
      pe = function pe() {
    return void 0 !== fe ? new oe(ie, ue, ce) : new K(ie, ue, ce);
  },
      de = "true" === se ? new le() : pe(),
      he = function he(e, t) {
    return t.some(function (t) {
      return e.includes(t);
    });
  },
      ge = function ge(e) {
    var t = e.children,
        n = e.roles,
        r = a.useSelector(function (e) {
      return e.global.auth.roles;
    });
    return he(r, n) && t;
  };

  ge.propTypes = {
    roles: l.arrayOf(l.string).isRequired,
    children: l.node.isRequired
  };
  var ye = "AUTH_INIT_LOGIN",
      me = "AUTH_LOGIN_SUCCESS",
      ve = "AUTH_LOGIN_FAILURE",
      ke = "AUTH_LOGOUT";

  function be() {
    if (de.loggedIn()) {
      var e = de.token,
          t = de.roles;
      return new D().setLoggingIn(!1).setLoggedIn(!0).setToken(e).setRoles(t()).setError("");
    }

    return new D();
  }

  var Oe = function (e) {
    Q(n, e);
    var t = ee(n);

    function n(e) {
      var r;
      return q(this, n), (r = t.call(this, e)).state = {
        hasError: !1
      }, r;
    }

    return N(n, [{
      key: "componentDidCatch",
      value: function value(e, t) {}
    }, {
      key: "render",
      value: function value() {
        var e = this.state,
            t = this.props;
        return e.hasError ? t.errorComponent() : t.children;
      }
    }], [{
      key: "getDerivedStateFromError",
      value: function value(e) {
        return {
          hasError: !0
        };
      }
    }]), n;
  }(t.Component);

  e.Auth = D, e.ErrorBoundary = Oe, e.LanguageConsumer = A, e.LanguageContext = I, e.LanguageProvider = L, e.LanguageRouting = function (e) {
    var r = e.location,
        a = e.AppContainer,
        i = m(E(), 2),
        u = i[0],
        c = u.currentLanguage,
        s = u.supportedLanguages,
        l = i[1];
    return t.useEffect(function () {
      !function (e) {
        var t = e.changeLanguage,
            n = e.supportedLanguages,
            r = e.location,
            o = e.lang;
        x(r, n, o) && t(function (e) {
          return {
            lang: e,
            type: "CHANGE_LANGUAGE"
          };
        }(S(r)));
      }({
        changeLanguage: l,
        lang: c,
        supportedLanguages: s,
        location: r
      });
    }), f.createElement(n.Switch, null, f.createElement(n.Route, {
      path: "/:lang(".concat(o.join(s, "|"), ")"),
      component: a
    }), f.createElement(n.Route, {
      component: R
    }));
  }, e.Link = function (e) {
    var t = e.to,
        r = v(e, ["to"]),
        o = m(E(), 1)[0],
        a = o.supportedLanguages,
        i = o.currentLanguage;
    return f.createElement(n.Link, Object.assign({}, r, {
      to: T(t, a, i)
    }));
  }, e.MemoryRouter = C, e.OAuthAuthenticationService = de, e.OAuthService = K, e.PrivateRoute = G, e.Redirect = P, e.Route = h, e.Router = p, e.SecureComponent = ge, e.Switch = function (e) {
    return f.createElement(n.Switch, e);
  }, e.addLanguagePrefix = T, e.authReducer = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : be(),
        t = arguments.length > 1 ? arguments[1] : void 0;

    switch (t.type) {
      case ye:
        return new D(e).setLoggingIn(!0).setError("").setRoles([]).setUsername(t.payload.username);

      case ve:
        return new D(e).setLoggingIn(!1).setLoggedIn(!1).setRoles([]).setToken("").setError(t.payload.error);

      case me:
        return new D(e).setLoggingIn(!1).setLoggedIn(!0).setToken(t.payload.token).setRoles(t.payload.token.roles).setError("");

      case ke:
        return new D();

      default:
        return e;
    }
  }, e.initLoginAction = function (e, t) {
    return {
      type: ye,
      payload: {
        username: e,
        password: t
      }
    };
  }, e.loginFailedAction = function (e) {
    return {
      type: ve,
      payload: {
        error: e
      }
    };
  }, e.loginSucceededAction = function (e) {
    return {
      type: me,
      payload: {
        token: e
      }
    };
  }, e.logoutAction = function () {
    return {
      type: ke,
      payload: ""
    };
  }, e.useLanguage = function () {
    var e = m(E(), 1)[0];
    return [e, function (t) {
      return _(t, e.supportedLanguages, e.currentLanguage);
    }];
  }, e.useLanguageValue = E, e.withRouter = d, e.withSecurity = function (e, t) {
    return function (n) {
      var r = Object.assign({}, n),
          o = a.useSelector(function (e) {
        return e.global.auth.roles;
      });
      return he(o, t) && f.createElement(e, r);
    };
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});